import { render, staticRenderFns } from "./ReserveFundFunds.vue?vue&type=template&id=6af735a4&"
import script from "./ReserveFundFunds.vue?vue&type=script&lang=js&"
export * from "./ReserveFundFunds.vue?vue&type=script&lang=js&"
import style0 from "./ReserveFundFunds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports